<template>
    <div :id="idName" :class="className">
        <div v-if="isBusy">
            <b-skeleton></b-skeleton>
        </div>
        <div v-else>
            {{ textValue }}
        </div>
    </div>
</template>
<script>
import DataSource from '@/models/DataSource/DataSource';

export default {
    props: {
        value: {
            default: "",
            type: [Number, String],
        },
        dataSourceId: {
            default: "",
            type: [Number, String],
        },
        dataSourceValue: {
            default: "",
            type: [Number, String],
        },
        dataSourceParentName: {
            default: "",
            type: String,
        },
        dataSourceParentValue: {
            default: "",
            type: [Number, String],
        },
        className: {
            default: "",
            type: String,
        },
        idName: {
            default: "",
            type: String,
        }
    },
    data() {
        return {
            textData : "-",
            isBusy : false
        };
    },
    mounted() {
        if (this.dataSourceId != null && this.dataSourceId != "" && this.dataSourceId != undefined) {
            this.getDataSource();
        }
    },
    computed : {
        textValue() {
            if (this.value != "" && this.dataSourceId != null) {
                return this.value;
            }
            return this.textData;
        }
    },
    methods: {
        getDataSource() {
            this.isBusy = true;
			DataSource.getData(this, this.dataSourceId)
            .then(result => { 
                if (Array.isArray(result)) {
                    if (result.length > 0) {
                        let model = result[0];
                        if (model[this.dataSourceValue] != undefined && model[this.dataSourceValue] != null) {
                            this.textData = model[this.dataSourceValue];
                        }
                    }
                }
                this.model = result; 
                this.isBusy = false;
            })
            .catch(error => { 
                this.isBusy = false; 
            });
        }
    }
}
</script>